import { NocfoTheme } from '../styled'
import nocfoTheme from './nocfo'

const theme: NocfoTheme = {
  ...nocfoTheme,
  assets: {
    logo: 'https://cdn.nocfo.io/third-party/fina360/logo-dark.svg',
    logoLight: 'https://cdn.nocfo.io/third-party/fina360/logo-light.svg'
  }
}

export default theme
